export class FilterFormulaGroup{
    description!: string;
}